import { render, staticRenderFns } from "./ScreenResolution.vue?vue&type=template&id=f7f96380&scoped=true"
import script from "./ScreenResolution.vue?vue&type=script&lang=js"
export * from "./ScreenResolution.vue?vue&type=script&lang=js"
import style0 from "./ScreenResolution.vue?vue&type=style&index=0&id=f7f96380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f96380",
  null
  
)

export default component.exports